import styled from 'styled-components';
import { media } from 'theme/breakpoints';
import { StyledButton } from 'components/ui/button';
import { SignUpForm } from 'components/styled/SignUpForm';

export const StartUsing = styled.section`
  display: flex;
  width: 100%;
  background-color: #f8d047;
  border-radius: 4px;
  justify-content: space-between;
  overflow: hidden;
  padding: 80px;
  margin-top: ${(props) => (props.deleteMarginTop ? 0 : '120px')};
  align-items: center;
  margin-bottom: ${(props) => (props.deleteMarginBottom ? 0 : '144px')};
  ${media.desktop} {
    flex-direction: column;
  }
  ${media.tablet} {
    margin-top: ${(props) => (props.deleteMarginTop ? 0 : '100px')};
    padding: 40px 20px;
    margin-bottom: ${(props) => (props.deleteMarginBottom ? 0 : '100px')};
    width: calc(100% - 32px);
  }
  ${media.mobile} {
    height: auto !important;
  }
  h2 {
    flex-basis: 50%;
    margin-right: 80px;
    line-height: 54px;
    ${media.tablet} {
      font-size: 28px;
      line-height: 42px;
      & span {
        display: none;
      }
    }
    ${media.desktop} {
      text-align: center;
      margin-right: 0;
    }
  }
  .start {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 100%;
    flex-basis: 50%;

    .checkmarks {
      margin: 20px 0 0;
      display: grid;
      grid-template-columns: repeat(3, max-content);
      grid-column-gap: 42.5px;
      justify-content: center;
      ${media.mobile} {
        justify-content: start;
        grid-template-columns: repeat(1, max-content);
        grid-gap: 8px;
      }
      p {
        margin-bottom: 0;
        display: flex;
        font-size: 14px;
        position: relative;
        text-align: center;
        line-height: normal;
        ${media.mobile} {
          margin-left: 17.5px;
          font-size: 16px;
          font-weight: 600;
        }
        & span {
          margin-left: 4px;
          ${media.mobile} {
            display: none;
          }
        }
        &::after {
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 50%;
          position: absolute;
          background-color: #000;
          top: 50%;
          left: -22.5px;
          transform: translateY(-50%);
          ${media.mobile} {
            left: -17.5px;
          }
        }
      }
    }
  }
`;

export const ExtendSignUpForm = styled(SignUpForm)`
  & label input {
    width: 314px;
    border: 2px solid #000000;
    transition: 0.2s ease;
    &:hover {
      border-color: #000;
    }
    ${media.mobile} {
      width: 100%;
      margin-bottom: 16px;
    }
  }
  ${media.desktop} {
    margin-top: 32px;
  }
  button,
  input {
    border-radius: 4px;
  }
`;

export const CustomButton = styled(StyledButton)`
  font-size: 16px;
  line-height: 20px;
  border-radius: 4px;
  padding: 12px 28px;
  ${media.tablet} {
    width: 100% !important;
    max-width: 314px !important;
  }
  ${media.mobile} {
    max-width: -webkit-fill-available !important;
  }
`;
